export const EVENT_NAME = {
  FAVORITE_DATA_TYPE: "Set Default Handicapping View",
  DATA_TYPE: "Select Handicapping View",
  OPEN_MODAL: "Open",
  SORT_FAVORITE_DATA_TYPE: "Set Default Sort View",
  SORT_DATA_TYPE: "Program Sort Applied"
};
